import _set from 'lodash/set';
import _isEmpty from 'lodash/isEmpty';

export const isToggledCountry = countryCode => true;

export const injectUuidToPOIs = (pois, uuid) => {
  if (!_isEmpty(pois)) {
    pois.forEach(poi => injectUuidToPOI(poi, uuid));
  }
};

export const injectUuidToPOI = (poi, uuid) => {
  if (poi) {
    _set(poi, 'metadata.uuid', uuid);
  }
};

export default {};
